import { render } from "./recover-password.html?vue&type=template&id=62f99276&ts=true&external"
import script from "./recover-password.ts?vue&type=script&lang=ts&external"
export * from "./recover-password.ts?vue&type=script&lang=ts&external"

import "./recover-password.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__